import React, { useState, useEffect } from 'react';
import SEO from '../components/common/SEO';
import SchemaMarkup from '../components/common/SchemaMarkup';

import Hero from '../components/home/Hero';
import AboutSection from '../components/home/AboutSection';
import CoursesSection from '../components/home/CoursesSection';
import StatsSection from '../components/home/StatsSection';
import FeaturesSection from '../components/home/FeaturesSection';
import TeamSection from '../components/home/TeamSection';
import TestimonialsSection from '../components/home/TestimonialsSection';
import CtaSection from '../components/home/CtaSection';
import { coursesAPI } from '../services/api';
import { useCompany } from '../contexts/CompanyContext';

const Home = () => {
  const { company, loading: companyLoading } = useCompany();
  const [featuredCourses, setFeaturedCourses] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const coursesResponse = await coursesAPI.getFeatured();
        setFeaturedCourses(coursesResponse.data.data);
      } catch (error) {
        console.error('Error fetching courses data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading || companyLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="loading-spinner"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen">
      <SEO 
        title="Prime Edge - Advanced Engineering Training"
        description="Elevate your engineering skills with Prime Edge's cutting-edge courses, expert instructors, and industry-recognized certifications."
        keywords="engineering courses, professional development, technical training, certification programs, engineering skills"
        canonicalUrl="/"
      />
      <SchemaMarkup 
        type="WebSite"
        name="Prime Edge - Advanced Engineering Training"
        description="Elevate your engineering skills with Prime Edge's cutting-edge courses, expert instructors, and industry-recognized certifications."
        url="https://primeedge-solutions.com"
        breadcrumbData={[
          { name: 'Home', url: 'https://primeedge-solutions.com' }        ]}
      />
      {/* Hero Section */}
      <Hero company={company} />
      
      {/* About Section */}
      <AboutSection company={company} />
      
      {/* Stats Section */}
      <StatsSection company={company} />
      
      {/* Features Section */}
      <FeaturesSection />
      
      {/* Courses Section */}
      <CoursesSection courses={featuredCourses} />
      
      {/* Team Section */}
      <TeamSection />
      
      {/* Testimonials Section */}
      <TestimonialsSection />
      
      {/* CTA Section */}
      <CtaSection company={company} />
    </div>
  );
};

export default Home;
